<template>
  <div class="settings mt-5">
      <b-row>
        <b-col md="12 text-center">
          <h5>{{ titleInfo.title }} @{{ titleInfo.room }}</h5>
        </b-col>
      </b-row>

      <div style="padding: 0 5vw;">
        <b-button size="sm" @click="refresh_stats()" variant="primary">
          Refresh All
        </b-button>
        <b-button size="sm" @click="enlarge_stats()" variant="primary">
          Enlarge
        </b-button>
        <b-button size="sm" @click="reduce_stats()" variant="primary">
          Reduce
        </b-button>
        <div id="allcharts">
        </div>
      </div>
      
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "stats",
  components: {
  },
  created() {
    let vue = this;
    //this.addLegacyScripts();
    vue.setup_room(vue, window.vx, vue.$router.currentRoute.params.acc, vue.$router.currentRoute.params.uid);
  },
  data() {
    return {
      site_url: process.env.VUE_APP_SITE_URL,
      vxScriptSettings: process.env.BASE_URL + "legacy/js/settings.js",
      titleInfo: { title: "", room: "()" },
    };
  },
  watch: {
    $route(to, from) {
      // eslint-disable-next-line
      console.log("watch:" + from.params.acc+"/"+from.params.uid + " " + to.params.acc+"/"+ to.params.uid);
      this.setup_room(this, window.vx, to.params.acc, to.params.uid);
    },
  },
  methods: {
    setup_room: function(vue, vx, room_acc, room_name) {
      $("#allcharts").html("");
      delete window.mycharts;
      window.vx_set_room(vx, room_acc, room_name);
      if (vx.room.name) {
        vue.titleInfo.room = room_name;
        vue.titleInfo.title = "";
        vue.get_stats(vx, room_acc, room_name);
      }
    },
    refresh_stats: function() {
      let vue = this;
      vue.get_stats(window.vx, window.vx.room.acc, window.vx.room.name);
    },
    enlarge_stats: function() {
      window.mycharts.forEach(function(chart) {
         chart.vx_min = Math.trunc(chart.vx_min / 2);
         chart.vx_max = Math.trunc(chart.vx_max / 2);
         chart.options.scales.yAxes[0].ticks.min = chart.vx_min;
         chart.options.scales.yAxes[0].ticks.max = chart.vx_max;
         chart.update();
      });
    },
    reduce_stats: function() {
      window.mycharts.forEach(function(chart) {
         chart.vx_min = Math.trunc(chart.vx_min * 1.2);
         chart.vx_max = Math.trunc(chart.vx_max * 1.2);
         chart.options.scales.yAxes[0].ticks.min = chart.vx_min;
         chart.options.scales.yAxes[0].ticks.max = chart.vx_max;
         chart.update();
      });
    },
    get_stats: function(vx, room_acc, room_name) {
      vx_api.getRoomStats(window.vx, room_acc, room_name)
        .then(res => {
           //console.log(JSON.stringify(res));
           window.mycharts = [];
           let h = '';
           res.stats.forEach(function(info) {
              h += '<div id="cont_'+info.uid+'" style="position: relative; height:250px;"> <canvas id="chart_'+info.uid+'" height:"300px" style="border: 1px solid black;"> </canvas></div>';
           });
           $("#allcharts").html(h);

           for (let i=0; i<res.stats.length; i++) {
             let info = res.stats[i];
             //console.log("Chart:"+JSON.stringify(info));
             let opt = {
               type: 'line',
               data: {
                 labels: [],
                 datasets: [],
               },
               options: {
                 title: {
                   display: true,
                   position: "left",
                   text: info.dname+" ("+info.recstate+")",
                 },
                 animation: {
                   duration: 1
                 },
                 legend: {
                   display: true,
                   position: "right",
                   labels: {
                     boxWidth: 20,
                   }
                 },
                 responsive: true,
                 maintainAspectRatio: false,
                 scales: {
                   xAxes: [{
                     type: "time",
                     display: false,
                     scaleLabel: {
                       display: true,
                       labelString: 'Date'
                     }
                   }],
                   yAxes: [{
                     type: "linear",
                     display: true,
                     position: "left",
                     id: "y-axis-1",
                     ticks: {
                     }
                   }]
                 }
               }
             };
             opt.data.datasets.push({
                 label:"delay", //vdelta
                 backgroundColor: 'rgba(0,0,0,0)',
                 borderColor: 'rgba(5,5,5,1)',
                 borderWidth: 1.5,
                 pointRadius: 2,
                 yAxisID: "y-axis-1",
                 data:[]});
             opt.data.datasets.push({
                 label:"adj", //vadj
                 backgroundColor: 'rgba(0,0,0,0)',
                 borderColor: 'rgba(150,5,5,1)',
                 borderWidth: 1.5,
                 pointRadius: 2,
                 yAxisID: "y-axis-1",
                 data:[]});
             opt.data.datasets.push({
                 label:"src lat", // obstm
                 backgroundColor: 'rgba(0,0,0,0)',
                 borderColor: 'rgba(5,150,5,1)',
                 borderWidth: 1.5,
                 pointRadius: 2,
                 yAxisID: "y-axis-1",
                 data:[]});
             opt.data.datasets.push({
                 label:"encoder", // obsfrm
                 backgroundColor: 'rgba(0,0,0,0)',
                 borderColor: 'rgba(5,5,150,1)',
                 borderWidth: 1.5,
                 pointRadius: 2,
                 yAxisID: "y-axis-1",
                 data:[]});
             let min = -40;
             let max = 40;
             if (info.stats) {
                info.stats = info.stats.sort(function(a,b){return a[0]-b[0];})
                info.stats.forEach(function(s) {
                   opt.data.labels.push(s[0]);
                   opt.data.datasets[0].data.push(-1*s[1]);
                   opt.data.datasets[1].data.push(s[2]);
                   opt.data.datasets[2].data.push(s[3]);
                   opt.data.datasets[3].data.push(s[4]);
                   if (-1*s[1] < min) min = -1*s[1];
                   if (s[2] < min) min = s[2];
                   if (s[3] < min) min = s[3];
                   if (s[4] < min) min = s[4];
                   if (-1*s[1] > max) max = -1*s[1];
                   if (s[2] > max) max = s[2];
                   if (s[3] > max) max = s[3];
                   if (s[4] > max) max = s[4];
                });
             }
             let jq = $("#chart_"+info.uid)[0];
             let ctx = jq.getContext('2d');
             let chart = new Chart(ctx, opt);
             chart.vx_min = min;
             chart.vx_max = max;
             window.mycharts.push(chart);
           }
        });
    },
  },
  computed: {
    room: sync("room"),
    user: function() {
      return this.$user.get();
    }
  },
  mounted() {},
  beforeDestroy() {
    //this.removeLegacyScripts();
    delete window.mycharts;
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 760px;
}
</style>
